export interface GlobalState {
  APIErrors: string | null;
}

export const DefaultGlobalState: GlobalState = { APIErrors: null };
